import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultCheckBoxGroupSetting,
  defaultDivideSetting,
  defaultSelectSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "mainSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      widthAuto: true,
      heightAuto: true,
    },
    extraConfig: {
      noFull: true,
    }
  },
  {
    name: "mainCheckbox",
    desc: "",
    type: "checkBoxGroupSet",
    defaultValue: {
      ...defaultCheckBoxGroupSetting,
      checkBoxValue: ["天","时","分","秒"],
      checkBoxList: [{
        label: "year",
        value: "年"
      },{
        label: "month",
        value: "月"
      },{
        label: "day",
        value: "天"
      },{
        label: "hours",
        value: "时"
      },{
        label: "minutes",
        value: "分"
      },{
        label: "seconds",
        value: "秒"
      }]
    }
  },
  {
    name: "mainMargin",
    desc: "间距",
    type: "numberSet",
    defaultValue: 8,
    unit: "px",
    extraConfig: {
      suffix: "px",
    }
  },
  {
    name: "mainDivide",
    type: "divideSet",
    defaultValue: {
      ...defaultDivideSetting,
    }
  },
  {
    name: "mainBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting,
    extraConfig: {
      title: "图片&渐变"
    }
  },
  {
    name: "mainBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "showMainBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "mainRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "mainOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    },
    extraConfig: {
      suffix: "%",
    }
  },
  {
    name: "mainShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    },
    extraConfig: {
      title: '阴影',
    }

  },
  {
    name: "mainPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 8,
    }
  },
  {
    name: "mainEnd",
    desc: "倒计时完成后",
    type: "selectSet",
    defaultValue: {
      ...defaultSelectSetting,
      title: '倒计时完成后',
      selectOptions: [{
        label: '停止计时',
        value: 'stop'
      }, {
        label: '开始正计时',
        value: 'restart'
      }],
      value: 'stop'
    }
  }
]

export const menuSetting = [
  // {
  //   type: "collapse",
  //   title: "尺寸",
  //   settings: ["mainSize"]
  // },
  {
    type: "collapse",
    title: "显示",
    settings: ["mainCheckbox"]
  },
  {
    type: "collapse",
    title: "排列",
    settings: ["mainMargin"]
  },
  {
    type: "collapse",
    title: "分隔符",
    settings: ["mainDivide"]
  },
  {
    type: "collapse",
    title: "背景",
    settings: ["mainBackground"]
  },
  {
    type: "collapse",
    title: "边框",
    initStatus: 'closed',
    settings: [
      {
        type: "basic",
        name: "mainBorder",
      },
      "mainRadius"
    ]
  },
  {
    type: "collapse",
    title: "边距",
    initStatus: 'closed',
    settings: ["mainPadding"]
  },
  {
    type: "collapse",
    title: "更多",
    initStatus: 'closed',
    settings: ["mainOpacity", "mainShadow", 'mainEnd']
  }
]
